import _ from '@lodash'
import TiptapEditor from 'app/main/composeMessage/tiptapEditor/TiptapEditor'
import { withFormsy } from 'formsy-react'
import { isEmptyOrNil } from 'libs/empty'
import { htmlToTextCount } from 'libs/text'
import * as R from 'ramda'
import React from 'react'
import { useIntl } from 'react-intl'

export const tiptapLengthValiator = R.curry((maxLength, values, value) => {
  const imgTags = value.match(/<img [^>]*src="[^"]*"[^>]*>/gm) || []
  const videoTags = value.match(/<video [^>]*src="[^"]*"[^>]*>/gm) || []
  const fileLinks =
    value.match(/<a [^>]*href="[^"]*"[^>]*download[^>]*>/gm) || []

  return (
    (htmlToTextCount(value) <= maxLength && htmlToTextCount(value) > 0) ||
    imgTags.length > 0 ||
    videoTags.length > 0 ||
    fileLinks.length > 0
  )
})

function removeBrAfterParagraph(html) {
  return html.replace(/<\/p>\s*<br\s*\/?>/gi, '</p>')
}

function TiptapFormsy(props) {
  const { formatMessage } = useIntl()
  const importedProps = _.pick(props, [
    'classes',
    'id',
    'label',
    'name',
    'maxLength',
    'value',
    'textStatus',
    'controls',
    'required',
    'isControlsInline',
    'isDoNotTranslateEnable',
    'isNoRichFormat',
    'linkEnabled',
    'tabIndex',
    'extraMsg',
    'readOnly',
    'onUploading',
    'onUploaded',
    'scrollableContainer',
    'onChangeImage',
  ])

  const error = props.errorMessage
  const value = removeBrAfterParagraph(props.value) || ''

  const changeValue = React.useCallback(
    function (value) {
      props.setValue(value)
      if (props.onChange) {
        props.onChange(value)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [props.setValue],
  )

  return (
    <TiptapEditor
      name={importedProps.name}
      placeholder={formatMessage({
        id: 'createNotification.title.placeholder',
      })}
      value={value}
      maxLength={10000}
      onUploading={props.onUploading}
      onUploaded={props.onUploaded}
      className="mb-4"
      error={!isEmptyOrNil(error)}
      errorMessage={error}
      onChange={(content) => {
        changeValue(content)
      }}
      onError={() => {
        props.setError(undefined)
      }}
    />
  )
}

export default React.memo(withFormsy(TiptapFormsy))
